// function updateSidebarPosition() {
//   const menu = document.querySelector('.sidebar-nav #menu');
//   if (!menu) return;

//   const windowWidth = window.innerWidth;

//   if (windowWidth <= 998) return; // pas de positionnement sur mobile

//   if (windowWidth <= 1700) {
//     // Collé à droite de l'écran
//     menu.style.right = '300px';
//   } else if (windowWidth <= 2000) {
//     // Décalé de 175px depuis la droite
//     menu.style.right = '175px';
//   } else {
//     // Décalé de 150px depuis la droite
//     menu.style.right = '150px';
//   }
// }

document.addEventListener('DOMContentLoaded', () => {
  // updateSidebarPosition();
  // window.addEventListener('resize', updateSidebarPosition);

  const checkbox = document.querySelector('#menuToggle input');
  const overlay = document.querySelector('.sidebar-overlay');

  if (checkbox && overlay) {
    checkbox.addEventListener('change', () => {
      if (checkbox.checked) {
        overlay.classList.add('visible');
        overlay.removeAttribute('hidden');
        document.body.style.overflow = 'hidden';
      } else {
        overlay.classList.remove('visible');
        overlay.setAttribute('hidden', '');
        document.body.style.overflow = '';
      }
    });

    overlay.addEventListener('click', () => {
      checkbox.checked = false;
      overlay.classList.remove('visible');
      overlay.setAttribute('hidden', '');
      document.body.style.overflow = '';
    });
  }

  // Niveau 1 ➜ 2
  document.querySelectorAll('.submenu-slide').forEach(btn => {
    btn.addEventListener('click', () => {
      const targetId = btn.getAttribute('data-target');
      const title = btn.getAttribute('data-title');
      const panel = document.getElementById(targetId);
      if (panel) {
        const backTitle = panel.querySelector('.back-title');
        if (backTitle) {
          backTitle.textContent = title;
        }
        panel.classList.add('active');
      }
    });
  });

  // Retour niveau 2
  document.querySelectorAll('.slide-back .arrow-return').forEach(btn => {
    btn.addEventListener('click', () => {
      const panel = btn.closest('.panel-level-2');
      if (panel) {
        panel.classList.remove('active');
      }
    });
  });

  // Toggle niveau 3
  document.querySelectorAll('.submenu-toggle.plusminus, .full-toggle').forEach(toggle => {
    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const li = toggle.closest('li.has-submenu');
      if (li) li.classList.toggle('submenu-open');
    });
  });
});